import { Button, Stack, Text, useTheme } from '@ltvco/refresh-lib/theme';
import { useScreenSize } from '@ltvco/refresh-lib/utils';
import { useNavigate } from 'react-router-dom';

import imgMoneyDeal from 'images/img_money_deal.svg';

import { SearchSettlementsCTAContainer } from './components';

export const SearchSettlementsCTA = () => {
  const { isMobile } = useScreenSize();
  const theme = useTheme();
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/dashboard/court-cases/class-action-lawsuits');
  };

  return (
    <SearchSettlementsCTAContainer isMobile={isMobile}>
      <Stack
        direction={isMobile ? 'column' : 'row'}
        gap={2}
        alignItems="center"
        justifyContent="center"
        width="100%"
      >
        <img src={imgMoneyDeal} alt="Settlements CTA" width={70} height={70} />
        <Stack
          gap={isMobile ? 1 : 0}
          alignItems={isMobile ? 'center' : 'flex-start'}
          justifyContent="center"
          width={isMobile ? '100%' : 'auto'}
        >
          <Text variant="h5" align={isMobile ? 'center' : 'left'}>
            You could be owed even more
          </Text>
          <Text variant="body1" align="center">
            Search for companies that may owe you a payout from a class action
            settlement.
          </Text>
        </Stack>
        <Button
          variant="contained"
          color="primary"
          size="large"
          fullWidth={isMobile}
          sx={{
            padding: theme.spacing(1, 3),
            marginLeft: isMobile ? 0 : 'auto',
          }}
          onClick={handleClick}
        >
          <Text variant="body1" fontWeight={700}>
            Search Settlements
          </Text>
        </Button>
      </Stack>
    </SearchSettlementsCTAContainer>
  );
};
